export default __webpack_public_path__ + "static/media/new_program.9bc65e34.jpg";